import { useLogin } from '@bnnvara/accounts';
import { track } from '@bnnvara/analytics/src/track';
import { FollowBrandButton } from '@bnnvara/buttons';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import { BrandCard } from '../../cards/BrandCard/BrandCard';
import { useIsFollowedByUser } from '../../FollowBrand/useIsFollowedByUser';
import * as S from './styled';

export function FollowableBrandCard({
  id,
  slug,
  name,
  backgroundImageUrl,
  brandId,
}) {
  const { isLoggedIn } = useLogin();
  const { toggle } = useIsFollowedByUser(brandId, {
    name,
    slug,
    backgroundImageUrl,
  });
  const category = `Profiel_${isLoggedIn ? 'ingelogd' : 'uitgelogd'}`;

  async function handleButtonClick() {
    track('profiel', 'click', 'volgen');

    await toggle();
  }

  return (
    <GridItem
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 4"
      columnEndXl="span 3"
      key={id}
    >
      <S.FollowableLink
        href={slug}
        category={category}
        action="click"
        label={name}
      >
        <BrandCard name={name} image={backgroundImageUrl} />
      </S.FollowableLink>

      <S.FollowableButtonContainer>
        <FollowBrandButton
          color="black"
          onClick={handleButtonClick}
          isFollowedByUser={false}
        />
      </S.FollowableButtonContainer>
    </GridItem>
  );
}

FollowableBrandCard.propTypes = {
  backgroundImageUrl: PropTypes.string,
  id: PropTypes.bool.isRequired,
  brandId: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};
